import { Form } from 'antd';
import SelectDateRadioButtonGroup from 'components/SelectDateRadioButtonGroup';
import DatePickerByTypeView from './DatePickerByTypeView';
import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';
import dayjs from 'dayjs';
import Box from 'components/Box';

const DateViewControls = () => {
    const form = Form.useFormInstance();
    const onChangeViewType = (value: CALENDAR_VIEW_TYPE) => {
        if (value === CALENDAR_VIEW_TYPE.DAY_VIEW) {
            form.setFieldValue('timePeriod', { startTime: dayjs(), endTime: dayjs() });
        } else if (value === CALENDAR_VIEW_TYPE.WEEK_VIEW) {
            form.setFieldValue('timePeriod', { startTime: dayjs().startOf('week'), endTime: dayjs().endOf('week') });
        } else if (value === CALENDAR_VIEW_TYPE.TWO_WEEKS) {
            form.setFieldValue('timePeriod', { startTime: dayjs().startOf('week'), endTime: dayjs().endOf('week').add(1, 'week') });
        } else if (value === CALENDAR_VIEW_TYPE.MONTH_VIEW) {
            form.setFieldValue('timePeriod', { startTime: dayjs().startOf('month'), endTime: dayjs().endOf('month') });
        }
    };
    return (
        <Box display='flex' flexDirection='row' gap={'2'}>
            <Form.Item name={'viewType'} noStyle>
                <SelectDateRadioButtonGroup onChange={onChangeViewType} />
            </Form.Item>
            <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => (
                    <Form.Item name={'timePeriod'} noStyle>
                        <DatePickerByTypeView viewType={getFieldValue('viewType')} />
                    </Form.Item>
                )}
            </Form.Item>
        </Box>
    );
};

export default DateViewControls;